import { render } from "./MessengerForm.vue?vue&type=template&id=e21f6164&scoped=true"
import script from "./MessengerForm.vue?vue&type=script&lang=js"
export * from "./MessengerForm.vue?vue&type=script&lang=js"

import "./MessengerForm.vue?vue&type=style&index=0&id=e21f6164&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e21f6164"

export default script